import Box from '@mui/material/Box'
import Lottie from "lottie-react";
import animation from "../images/Animation/kusumbasreeLottie.json";

const SplashScreen = () => {
  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      // bgcolor="#edd1e1"
    >
      <Lottie
        animationData={animation}
        loop
        autoplay
        style={{ height: 250, width: 250 }}
      />
    </Box>
  );
};

export default SplashScreen;
